///<reference path="../../../../node_modules/@types/node/index.d.ts"/>
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {ChartType} from './highchart-type.enum';
import {FilterInterface} from '../../search/search-list/filters/filter-block/filter-item/filter-interface';
import {Dataset} from './dataset';
import * as Plotly from 'plotly.js';
import {RangeEvent} from './range-event';
import {HtmlUtilsService} from "../../html-utils/html-utils.service";

@Component({
  selector: 'app-barchart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {

  private highContrast: boolean = false;
  @ViewChild('chart') el: ElementRef;
  @Input() empty = false;
  @Input() legend = false; // optional,
  @Input() title = ''; // optional,
  @Input() displayModeBar = false; // optional,
  @Input() scrollZoom = false; // optional,
  @Input() displaylogo = false; // optional,
  @Input() config: any; // optional, see https://plot.ly/javascript/configuration-options/#hide-the-plotly-logo-on-the-modebar
  @Input() indBarWidth: number; // required
  dataset: Dataset;
  @Input() chartClass: String = 'chart-div-classs';
  @Output() rangeChangedOnView: EventEmitter<RangeEvent> = new EventEmitter();
  private type: ChartType = ChartType.bar;
  private highContrastStyle = {
    backgroundColor: 'rgb(0,0,0)',
    plotColor: 'rgb(255,255,0)',
    axesColor: 'rgb(255,255,255)',
    labelsColor: 'rgb(255,255,255)',
  };
  private normalStyle = {
    backgroundColor: 'rgb(255,255,255)',
    plotColor: 'rgb(37,120,194)',
    axesColor: 'rgb(228,228,228)',
    labelsColor: 'rgb(0,0,0)',
  };

  private currentStyle = this.normalStyle;

  constructor(private htmlUtils: HtmlUtilsService) {
    this.highContrast = this.htmlUtils.contrast;
    this.updateChartStyles();
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
        this.updateChartStyles();
        this.updateDataSet();
      }
    });
  }

  private updateChartStyles() {
    if (this.highContrast) {
      this.currentStyle = this.highContrastStyle
    }
    else {
      this.currentStyle = this.normalStyle;
    }
  }


  private updateDataSet() {
    this.config = {
      title: this.title,
      showlegend: this.legend,
      autosize: true,
      height: 200,
      width: 220,
      nticks: 5,
      tickmode: 'auto',
      ticks: 'outside',
      showticklabels: 'true',
      plot_bgcolor: this.currentStyle.backgroundColor,
      paper_bgcolor: this.currentStyle.backgroundColor,
      margin: {
        l: 0,
        r: 0,
        b: 20,
        t: 0,
        pad: 0
      },
      font: {
        color: this.currentStyle.labelsColor
      },
      cliponaxis: true,
      xaxis: {
        layer: 'below traces',
        color: this.currentStyle.labelsColor
      },
      yaxis:
        {
          layer: 'below traces'
        },
      hovermode: 'closest'
    };
    if (this.dataset) {
      this.dataset.marker = {
        color: this.currentStyle.plotColor
      };
    }
    this.initPlot(this.el, [this.dataset], this.config);
  }

  @Input('dataSet') set dataSet(values: FilterInterface[]) {
    if (!this.empty) {
      this.dataset = new Dataset(
        values.map(v => v.value),
        values.map(v => v.count),
        values.map(v => v.value.substr(0, 4) + 'r.: ' + v.count + ' pozycji'),
        this.type);

      this.updateChartStyles();
      this.updateDataSet();
    }
  }

  ngOnInit() {
    if (!this.empty) {
      this.el.nativeElement.on('plotly_relayout', event => this.onResize(event));
    }

  }

  private initPlot(el: ElementRef, data: Dataset[], config: any) {
    Plotly.newPlot(el.nativeElement, data, config, {
      showTips: false,
      hoverinfo: 'text',
      displayModeBar: this.displayModeBar,
      scrollZoom: this.scrollZoom,
      displaylogo: this.displaylogo,
      modeBarButtonsToRemove: [
        'toImage',
        'sendDataToCloud',
        'zoom2d',
        'pan2d',
        'select2d',
        'lasso2d',
        'autoScale2d',
        'resetScale2d',
        'hoverClosestCartesian',
        'hoverCompareCartesian',
        'toggleSpikelines'
      ]
    });
  }

  private onResize(resizeData: any): void {
    let dateFrom: any, dateTo: any;
    dateFrom = resizeData['xaxis.range[0]'];
    dateTo = resizeData['xaxis.range[1]'];
    this.rangeChangedOnView.emit({dateFrom: Math.floor(dateFrom), dateTo: Math.ceil(dateTo)});
  }

}
